import * as React from "react";
const SvgWebcamVideoSquare1 = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V22.13H22.13V1.87H12ZM3.38 3.38H20.62V20.62H3.38V12Zm3.178 4.119v9.004h9.006v-1.898l1.164.388c.64.214 1.165.387 1.17.387.003 0 .007-1.52.007-3.379s-.004-3.379-.008-3.379-.53.175-1.17.389l-1.163.386V7.498h-4.504zm1.507 1.506h6v2.476l1.165-.388c.64-.214 1.165-.389 1.17-.389.003 0 .007.584.007 1.297s-.004 1.297-.008 1.297-.53-.175-1.17-.389l-1.164-.388v2.476h-6V12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgWebcamVideoSquare1;
